"use strict";

module.exports = {
  DOWN: 40,
  ESC: 27,
  ENTER: 13,
  LEFT: 37,
  RIGHT: 39,
  SPACE: 32,
  TAB: 9,
  UP: 38
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/utils/key-code.js
 ** module id = 217
 ** module chunks = 0
 **/